<!-- <app-add-product-crousel-cust [images]="['forum.jpeg', 'giveaway.jpeg']"></app-add-product-crousel-cust> -->
<div class="main-header">
  <div class="container">
    <div class="banner-with-nav">

      <img loading="lazy" *ngIf="url.includes('/forum') && !url.includes('giveaway') && !url.includes('poll')"
        class="my-banner" src="../../../assets/images/new/forum.jpg" alt="" />
      <img loading="lazy" *ngIf="url.includes('/giveaway')" class="my-banner"
        src="../../../assets/images/new/giveaway.jpeg" alt="" />
      <img loading="lazy" *ngIf="url.includes('/poll')" class="my-banner" src="../../../assets/images/new/poll.jpg"
        alt="" />
      <!-- <div class="back" (click)="goBack()">
        <i class="fa fa-caret-left back-btn"></i>
        Back
      </div> -->
      <div class="back-button-section">
        <button class="back-button" (click)="goBack()"><i class="fa fa-arrow-left" aria-hidden="true"></i> Back</button>
      </div>
      <div class="title-nav">
        <div class="all">
          <a routerLink="/forum" (click)="onNavigate('forum')" class="title-nav__item"
            routerLinkActive="active">Forum</a>
          <a routerLink="/giveaway" (click)="onNavigate('giveaway')" class="title-nav__item"
            routerLinkActive="active">Giveaway</a>
          <a routerLink="/poll" (click)="onNavigate('poll')" class="title-nav__item" routerLinkActive="active">Poll</a>
        </div>
      </div>
    </div>
    <div class="nav-forum-2">
      @if (!url.includes('giveaway') && !url.includes('poll')) {
      <div class="search">
        <input type="text" placeholder="Search your topic here" (keyup)="onSearch($event)" />
        <i class="fa-solid fa-magnifying-glass"></i>
      </div>
      } @else {
      <div></div>
      }

      <div class="slide-left">
        <div class="slide-left__item" *ngIf="!url.includes('giveaway') && !url.includes('poll')" (click)="openMenu()">
          <i class="fa-solid fa-bars"></i>
        </div>
      </div>
      <button (click)="openTopic()" *ngIf="!url.includes('giveaway') && !url.includes('poll')"><i
          class="fa-solid fa-paper-plane"></i> New Topic</button>
      <!-- <button (click)="openTopic()" *ngIf="url === '/forum/poll'"><i class="fa-solid fa-poll"></i> New Poll</button> -->
    </div>
  </div>
</div>


<router-outlet></router-outlet>